import React, { useState, useEffect } from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const tableQR = searchParams.get('table');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const allLinks = [
    { to: '/', label: 'Accueil' },
    { to: '/menu', label: 'Carte' },
    { to: '/boissons', label: 'Boissons' },
    { to: '/avis', label: 'Avis' },
    { to: '/contact', label: 'Contact' },
  ];

  const links = tableQR
    ? allLinks.filter(l => l.to === '/' || l.to === '/contact')
    : allLinks;

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'backdrop-blur-xl bg-stone-50/90 border-b border-stone-200/50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center py-4 px-6 md:px-12">
        <Link to="/" className="flex items-center gap-2" data-testid="navbar-logo">
          <img src="/logo-taverne.png" alt="La Taverne" className={`transition-all duration-300 ${scrolled ? 'h-12' : 'h-14'}`} />
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-10">
          {links.map(link => (
            <Link
              key={link.to}
              to={link.to}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className={`text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 ${
                scrolled ? 'text-stone-700 hover:text-red-900' : 'text-stone-200 hover:text-white'
              } ${location.pathname === link.to ? (scrolled ? 'text-red-900' : 'text-white') : ''}`}
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/staff/login"
            data-testid="nav-staff-login"
            className={`px-5 py-2 text-[10px] uppercase tracking-[0.15em] border transition-all duration-300 ${
              scrolled
                ? 'border-stone-900 text-stone-900 hover:bg-stone-900 hover:text-white'
                : 'border-white/50 text-white hover:bg-white/10'
            }`}
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Espace Staff
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button
          className="md:hidden"
          onClick={() => setIsOpen(!isOpen)}
          data-testid="mobile-menu-toggle"
        >
          {isOpen ? (
            <X size={24} className={scrolled ? 'text-stone-900' : 'text-white'} />
          ) : (
            <Menu size={24} className={scrolled ? 'text-stone-900' : 'text-white'} />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-stone-50 border-t border-stone-200 shadow-lg">
          <div className="flex flex-col py-4 px-6 space-y-4">
            {links.map(link => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setIsOpen(false)}
                className="text-sm uppercase tracking-widest text-stone-700 hover:text-red-900"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/staff/login"
              onClick={() => setIsOpen(false)}
              className="text-sm uppercase tracking-widest text-stone-500 hover:text-red-900 pt-2 border-t border-stone-200"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Espace Staff
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
